import {
  MeshBasicMaterial,
    MeshStandardMaterial,
  } from "three";


  export function extendShaderWithWorldGradient(material: MeshStandardMaterial, yStart: number, yEnd: number = 1.5) {
    material.onBeforeCompile = (shader) => {
      // Add custom uniforms
      shader.uniforms.yStart = { value: yStart };
      shader.uniforms.yEnd = { value: yEnd };
  
      shader.fragmentShader = shader.fragmentShader.replace(
        `uniform vec3 diffuse;\n`,
        `
        uniform vec3 diffuse;
        uniform float yStart;
        uniform float yEnd;
        `
      );
  
      shader.vertexShader = 'varying vec4 worldPosition;\n' + shader.vertexShader;
      shader.vertexShader = shader.vertexShader.replace(
        `#include <begin_vertex>`,
        `
        #include <begin_vertex>
        worldPosition = modelMatrix * vec4( transformed, 1.0 );
        `
      );
  
      shader.fragmentShader = 'varying vec4 worldPosition;\n' + shader.fragmentShader;
      shader.fragmentShader = shader.fragmentShader.replace(
        `#include <dithering_fragment>`,
        `
        float darkeningFactor = smoothstep(yStart, yStart - yEnd, worldPosition.y);
        vec3 gradientEffect = vec3(1.0 - darkeningFactor * 0.89);
        gl_FragColor.rgb *= gradientEffect;
        #include <dithering_fragment>
        `
      );
    };
  }

  export function extendShaderWithUVGradient(material: MeshBasicMaterial, yStart: number, yEnd: number = 1.5) {
    material.onBeforeCompile = (shader) => {
      // Add custom uniforms
      shader.uniforms.yStart = { value: yStart };
      shader.uniforms.yEnd = { value: yEnd };

      
      shader.vertexShader = 'varying vec4 worldPosition;\n' + shader.vertexShader;
      shader.vertexShader = 'varying vec2 vUv;\n' + shader.vertexShader;
      shader.vertexShader = shader.vertexShader.replace(
        `#include <begin_vertex>`,
        `
        #include <begin_vertex>
        worldPosition = modelMatrix * vec4( position, 1.0 );
        vUv = uv;
        `
      );

      shader.fragmentShader = shader.fragmentShader.replace(
        `uniform vec3 diffuse;\n`,
        `
        uniform vec3 diffuse;
        uniform float yStart;
        uniform float yEnd;
        `
      );

      shader.fragmentShader = 'varying vec2 vUv;\n' + shader.fragmentShader;
      shader.fragmentShader = 'varying vec4 worldPosition;\n' + shader.fragmentShader;
      shader.fragmentShader = shader.fragmentShader.replace(
        `#include <dithering_fragment>`,
        `
      //  if (worldPosition.y<0.06) discard;
        float uvCor = clamp( vUv.y,0.4,1.0);
        gl_FragColor.rgb *=  vec3(uvCor);

        
        
        #include <dithering_fragment>
        `
      );
    };
}



export function animateNormalMap(material: MeshStandardMaterial, speed: number) {
  material.onBeforeCompile = (shader) => {

    shader.uniforms.speed = { value: speed };
    shader.uniforms.time = { value: 0 };

    shader.vertexShader = 'varying vec4 worldPosition;\n' + shader.vertexShader;
      shader.vertexShader = shader.vertexShader.replace(
        `#include <begin_vertex>`,
        `
        #include <begin_vertex>
        worldPosition = modelMatrix * vec4( transformed, 1.0 );
        `
      );
    
     shader.fragmentShader = 'varying vec4 worldPosition;\n' + shader.fragmentShader;

    // Alter the fragment shader
    shader.fragmentShader = shader.fragmentShader.replace(
      `#include <normalmap_pars_fragment>`,
      `
      uniform float speed;
      uniform float time;
      #include <normalmap_pars_fragment>
      `
    );
    /*
    shader.fragmentShader=shader.fragmentShader.replace(
        "#include <normal_fragment_maps>",
        `#include <normal_fragment_maps>

        vec2 uvTranslate = vNormalMapUv;
        uvTranslate*=0.01;
        uvTranslate.y += (time)*0.01;
        
        vec3 sampledNormal =texture2D(normalMap, uvTranslate.xy).xyz*2.0-1.0;
        sampledNormal*=0.9;
        vec3 transformedNormal = normalize(sampledNormal); // Normalize the normal
        normal = sampledNormal;
        `
        );*/


    

    material.userData.shader = shader;
  };
}
